/* eslint-disable import/prefer-default-export */
const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT

const BACKEND_URL = ENVIRONMENT === 'local' ? 'http://localhost:8080' : ''

export { BACKEND_URL }
